export default __webpack_public_path__ + "static/media/pdg_fleet.6255b7ca.jpeg";